<script>
import EditPage from '@/components/views/EditPage';
export default {
  name: 'EditRevision',
  components: {
    EditPage
  }
};
</script>

<template>
  <edit-page />
</template>
